import type { PropsWithChildren } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'

function Toolbar({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  const intl = useIntl()

  return (
    <div
      aria-label={intl.formatMessage({ id: 'Table.actions' })}
      className="flex items-center justify-between px-6 py-3"
    >
      {children}
    </div>
  )
}

export default Toolbar
